type DownloadLinkProps = {
  img?: string;
  linkName?: string;
  url?: string;
  width?: string;
  withContainer?: boolean;
  target?: "_blank" | "_self" | "_parent" | "_top" | string;
};

export const DownloadLink = ({
  img,
  linkName,
  url,
  width,
  withContainer,
  target = "_blank"
}: DownloadLinkProps) => {
  return (
    <div className="download-container">
      <a target={target} href={url}>
        <img src={img}></img>
        <p>{linkName}</p>
      </a>
      <style jsx>{`
        .download-container {
          max-width: ${width ? width : "450px"};
          width: ${withContainer ? "unset" : "100%"};
          border-radius: ${withContainer ? "8px" : "unset"};
          box-shadow: ${withContainer ? "0px 2px 4px 0px rgba(26, 26, 26, 0.2)" : "unset"};
          padding: ${withContainer ? "3px 8px" : "unset"};
          display: flex;
        }
        .download-container a {
          display: flex;
        }
        .download-container:hover {
          cursor: pointer;
        }
        .download-container img {
          flex-shrink: 0;
          width: 26.67px;
          height: 26.67px;
          margin: auto;
          margin-right: 10px;
        }
        .download-container p {
          font-size: 16px;
          color: var(--color-red);
        }
        @media only screen and (max-width: 600px) {
          .download-container a {
            align-items: center;
          }
          .download-container p {
            font-size: 12px;
            margin-right: 16px;
          }
        }
      `}</style>
    </div>
  );
};
